import React, { useState } from 'react'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { SearchBox } from '@tecuity/granite-ui/SearchBox'
import { SelectBox } from '@tecuity/granite-ui/SelectBox'
import { Spinner } from '../../Loaders/Loaders'
import { getStateOptions } from '../../Wizard2/selectOptions'
import { BO_SEARCH } from '../../../requests'
import '../../WorkviewManager/WorkviewManager.scss'

// const frequentPayorLabel = process.env.FREQUENT_PAYOR_LABEL

const PayorSearchModalContent = ({ setShowPayorSearch, selectPayorAccount }) => {
  const [searchQuery, setSearchQuery] = useState(defaultQuery)
  const [showSpinner, setShowSpinner] = useState(false)
  const [searchResults, setSearchResults] = useState([])
  const [hasSearchBeenMade, setHasSearchBeenMade] = useState(false)

  const searchForAccounts = (query = searchQuery) => {
    setHasSearchBeenMade(true)
    setShowSpinner(true)
    setSearchResults([])
    BO_SEARCH(
      query,
      'FrequentPayorSearch',
      (results) => {
        setSearchResults(results)
        setShowSpinner(false)
      },
      (err) => {
        console.error(err)
        setShowSpinner(false)
      }
    )
  }
  return (
    <div className="wvm-modal">
      <div className="flex-column-wrapper paper-process-container">
        <div style={{ margin: '5px', padding: '15px' }}>
          <div className="filingSelectButtonWrapper noClear">
            <SearchBox
              label={`Account Name`}
              placeholder={`Account Name`}
              value={searchQuery.AccountName || ''}
              onChange={(value) => setSearchQuery((query) => ({ ...query, AccountName: value }))}
              showClearButton={false}
              showSearchButton={false}
              onSubmit={(value) => searchForAccounts({ ...searchQuery, AccountName: value })}
            />
            <SearchBox
              label={`Account Number`}
              placeholder={`Account Number`}
              value={searchQuery.AccountNum || ''}
              onChange={(value) => setSearchQuery((query) => ({ ...query, AccountNum: value }))}
              showClearButton={false}
              showSearchButton={false}
              onSubmit={(value) => searchForAccounts({ ...searchQuery, AccountNum: value })}
            />
            <SearchBox
              label={`City`}
              placeholder={`City`}
              value={searchQuery.City || ''}
              onChange={(value) => setSearchQuery((query) => ({ ...query, City: value }))}
              showClearButton={false}
              showSearchButton={false}
              onSubmit={(value) => searchForAccounts({ ...searchQuery, City: value })}
            />
            <SelectBox
              label={`State`}
              options={getStateOptions()}
              value={searchQuery.State || ''}
              onChange={(value) => {
                setSearchQuery((query) => ({ ...query, State: value }))
              }}
              customCss={{ select: { height: '40px', marginTop: '4px' } }}
              aria-label="State"
            />
            <div elevation="standard" className="search-bar">
              <ContextButton
                variant="secondary"
                onClick={() => {
                  setShowPayorSearch(false)
                }}
              >
                Close
              </ContextButton>
              <ContextButton
                variant="danger"
                onClick={() => {
                  setSearchQuery(defaultQuery)
                  setSearchResults([])
                  setHasSearchBeenMade(false)
                }}
              >
                Clear
              </ContextButton>
              <ContextButton variant="primary" onClick={() => searchForAccounts()}>
                Search
              </ContextButton>
            </div>
          </div>
          {searchResults.length === 0 && !showSpinner && (
            <div
              style={{
                textAlign: 'center',
                width: '100%',
              }}
            >
              <h1 style={{ padding: '15px', fontWeight: 'bold' }}>
                {hasSearchBeenMade
                  ? `No Records Found - Please Refine Search`
                  : `Please Search for Account`}
              </h1>
            </div>
          )}
          {showSpinner && (
            <div
              style={{
                marginTop: '80px',
                height: '100px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              className="form-blocks"
            >
              <div>
                <Spinner className="page-loader" themeColor="neutral" />
              </div>
            </div>
          )}
          <div className="search-wrapper paper-process-result-wrapper">
            {searchResults.length > 0 &&
              !showSpinner &&
              searchResults.map((account, i) => {
                const address = account.ContactAddress
                return (
                  <div
                    key={i}
                    className={`stacked-data-result paper-process-result-item`}
                    type="button"
                    onClick={() => {
                      selectPayorAccount(account)
                    }}
                  >
                    <div className="row">
                      <div className={`search-result`}>
                        {/*  */}
                        <span className="primary">{`${account.FrequentPayorName} (${account.FrequentPayorNum})`}</span>
                        <span className="secondary">City: {address.City}</span>
                        <span className="secondary">State: {address.StateOrProvince}</span>
                        <span className="secondary">
                          Balance: ${account.Balance.toFixed(2).toString()}
                        </span>
                      </div>
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PayorSearchModalContent

const defaultQuery = {
  AccountName: null,
  AccountNum: null,
  City: null,
  State: null,
}

// {
//   "FrequentPayorId": 2,
//   "FrequentPayorNum": "00001",
//   "FrequentPayorName": "Justini Tortellini III",
//   "ContactAddress": {
//       "AddressLine1": "1234 W MAIN ST",
//       "AddressLine2": "",
//       "AddressLine3": "",
//       "City": "LOS ANGELES",
//       "County": null,
//       "StateOrProvince": "CA",
//       "PostalCode": "90000",
//       "Country": "United States",
//       "ADDR1": "1234 W MAIN ST",
//       "ADDR2": "",
//       "ADDR3": "",
//       "CITY": "LOS ANGELES",
//       "COUNTY": null,
//       "STATE": "CA",
//       "POSTAL_CODE": "90000",
//       "COUNTRY": "United States"
//   },
//   "Balance": 0,
//   "LastModifiedByUserId": 7,
//   "LastModifiedDate": "2023-10-26T16:00:35.9466421"
// }
